import { call, put, takeLatest } from 'redux-saga/effects';
import api from 'services/api';
import swal from 'sweetalert';
import CPF from 'gerador-validador-cpf';

import { Creators as AttendancesActions, Types as AttendancesTypes } from 'store/ducks/attendances';

function* getAttendancesRequest(action) {
  try {
    const { id, page, filters } = action.payload;

    let filter = '';

    if (filters !== null) {
      const formatted = CPF.format(filters.cpf, 'digits');
      const cpf = filters.cpf !== '' && CPF.validate(filters.cpf) ? `&cpf=${formatted}` : '';
      const status = filters.status.value !== '' ? `&attendance_status=${filters.status.value}` : '';

      filter = `${cpf}${status}`;
    }

    const per = filters !== null ? filters.per.value : 25;

    const url = `feed/v2/events/${id}/attendances?page=${page}&per=${per}${filter}`;
    const response = yield call(api.get, url);

    yield put(AttendancesActions.getAttendancesSuccess(response.data));
  } catch (error) {
    yield put(AttendancesActions.getAttendancesFailure());
  }
}

function* createAttendanceRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = 'feed/v2/events/attendances';
    yield call(api.post, url, data);

    yield call(getAttendancesRequest, { payload: { id, filters: null } });
    yield call(getAttendancesDashboardRequest, { payload: { id } });

    yield put(AttendancesActions.createAttendanceSuccess());
  } catch (error) {
    yield call(swal, 'Ops', 'Não foi possível executar a ação', 'error');
    yield put(AttendancesActions.createAttendanceFailure());
  }
}

function* getAttendancesDashboardRequest(action) {
  try {
    const { id } = action.payload;

    const url = `feed/v2/events/${id}/attendances/dashboard`;
    const response = yield call(api.get, url);

    yield put(AttendancesActions.getAttendancesDashboardSuccess(response.data));
  } catch (error) {
    yield put(AttendancesActions.getAttendancesDashboardFailure());
  }
}

export default function* sagaAttendances() {
  yield takeLatest(AttendancesTypes.GET_LIST_REQUEST, getAttendancesRequest);
  yield takeLatest(AttendancesTypes.CREATE_REQUEST, createAttendanceRequest);
  yield takeLatest(AttendancesTypes.GET_DASHBOARD_REQUEST, getAttendancesDashboardRequest);
}
